(() => {
  const DAY = 86400000;
  const zone = 'Europe/Warsaw';
  const partsFormat = new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
  const parts = (date) => Object.fromEntries(partsFormat.formatToParts(date).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  const iso = (date) => date.toISOString().slice(0, 10);
  const shift = (date, days) => new Date(date.getTime() + days * DAY);
  const atCutoff = (date, hour, minute) => {
    const target = date.getTime() + hour * 3600000 + minute * 60000;
    let result = target;
    for (let i = 0; i < 3; i++) {
      const p = parts(new Date(result));
      result += target - Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second);
    }
    return result;
  };
  function calculate(now, { days, hour = 12, minute = 0, transitMin = 1, transitMax = 1, holidays = [] }) {
    if (!Number.isInteger(days) || days < 1 || days > 365) return null;
    const closed = new Set(holidays);
    const workday = d => d.getUTCDay() !== 0 && d.getUTCDay() !== 6 && !closed.has(iso(d));
    const nextWorkday = date => {
      let d = date;
      for (let i = 0; i < 1100; i++, d = shift(d, 1)) if (workday(d)) return d;
      throw new Error('No working date available');
    };
    const addWorkdays = (date, count) => {
      let d = date;
      for (let i = 0; i < count; i++) d = nextWorkday(shift(d, 1));
      return d;
    };
    const p = parts(now);
    const today = new Date(Date.UTC(p.year, p.month - 1, p.day));
    const beforeCutoff = p.hour * 60 + p.minute < hour * 60 + minute;
    const start = nextWorkday(workday(today) && beforeCutoff ? today : shift(today, 1));
    const dispatch = addWorkdays(start, days - 1);
    const minimum = Math.max(1, Math.min(20, Math.trunc(transitMin) || 1));
    const maximum = Math.max(minimum, Math.min(20, Math.trunc(transitMax) || 1));
    return { today, dispatch, earliest: addWorkdays(dispatch, minimum), latest: addWorkdays(dispatch, maximum), deadline: atCutoff(start, hour, minute) };
  }
  window.DrewdonDeliveryCalendar = Object.freeze({ calculate });
  if (customElements.get('drewdon-delivery')) return;
  class DrewdonDelivery extends HTMLElement {
    connectedCallback() {
      try {
        this.options = JSON.parse(this.querySelector('[data-dd-config]').textContent);
        this.tick = this.update.bind(this);
        this.update();
        this.timer = setInterval(this.tick, 15000);
        document.addEventListener('visibilitychange', this.tick);
      } catch { this.hidden = true; }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.tick);
    }
    update() {
      try {
        const now = new Date();
        const result = calculate(now, this.options);
        if (!result) { this.hidden = true; return; }
        const labels = this.options.labels;
        const locale = document.documentElement.lang || 'pl';
        const format = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: 'UTC' });
        const friendly = date => iso(date) === iso(result.today) ? labels.today : iso(date) === iso(shift(result.today, 1)) ? labels.tomorrow : format.format(date);
        const deliveryFormat = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC' });
        const singleDate = iso(result.earliest) === iso(result.latest);
        const deliveryTomorrow = singleDate && iso(result.earliest) === iso(shift(result.today, 1));
        const range = deliveryTomorrow ? labels.tomorrow : singleDate ? deliveryFormat.format(result.earliest) : deliveryFormat.formatRange(result.earliest, result.latest);
        this.querySelectorAll('[data-dd-delivery]').forEach(el => el.classList.toggle('dd-delivery__tomorrow', deliveryTomorrow));
        const put = (selector, value) => this.querySelectorAll(selector).forEach(el => { if (el.textContent !== value) el.textContent = value; });
        const minutes = Math.max(0, Math.ceil((result.deadline - now.getTime()) / 60000));
        put('[data-dd-countdown]', `${Math.floor(minutes / 60)} ${labels.hour} ${minutes % 60} ${labels.minute}`);
        const sameDay = iso(result.dispatch) === iso(result.today);
        const prompt = this.querySelector('[data-dd-prompt]');
        const later = this.querySelector('[data-dd-later]');
        if (prompt && later) {
          const weekdayToday = result.today.getUTCDay();
          const fridayAfterCutoff = weekdayToday === 5 && iso(result.dispatch) !== iso(result.today) && now.getTime() >= atCutoff(result.today, this.options.hour ?? 12, this.options.minute ?? 0);
          prompt.hidden = !this.options.showCountdown || fridayAfterCutoff || weekdayToday === 6;
          later.hidden = !prompt.hidden;
          let dispatchText = friendly(result.dispatch).toLocaleLowerCase(locale);
          if (!sameDay && iso(result.dispatch) !== iso(shift(result.today, 1))) {
            const weekday = result.dispatch.getUTCDay();
            dispatchText = locale.startsWith('pl') ? ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'][weekday] : format.format(result.dispatch);
            if ((result.dispatch - result.today) / DAY >= 7) dispatchText = format.format(result.dispatch);
          }
          put('[data-dd-today]', sameDay ? labels.shipsToday : labels.shipsOnCountdown.replace('__date__', dispatchText));
          put('[data-dd-later]', `${labels.shipsOn} ${dispatchText}`);
        }
        put('[data-dd-order]', labels.today);
        put('[data-dd-dispatch]', friendly(result.dispatch));
        put('[data-dd-delivery]', range);
        this.hidden = false;
      } catch { this.hidden = true; }
    }
  }
  customElements.define('drewdon-delivery', DrewdonDelivery);
})();


